<template>
  <div class="head-comp GlobalHeader">
    <a-icon type="menu" class="menuheader" @click="open" />
    <div class="head-comp-section-left">
      <img
        src="/logo.png"
        alt="logo"
        width="auto"
        height="100%"
        style="z-index: 3"
      />
      <h1>Sunshine Connected</h1>
    </div>
  <a-drawer

      placement="top"
      :closable="false"
      :visible="visible"
      @close="onClose"
    >
      <user-sider/>
    </a-drawer>
  </div>
</template>

<script>
import userSider from './user-sider.vue';
export default {
  components: { userSider },
  data(){
    return {
      visible:false
    }
  },
  methods: {
    handleFont(value) {
      document.querySelector("html").style.fontSize = value;
    },
    onClose(){
        this.visible=false
    },
    open(){
      this.visible=true
    }
  },
};
</script>

<style lang="less">
.ant-select:focus {
  outline: 1px solid black !important;
}

.head-comp {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .menuheader {
    display: none;
    font-size: 3rem;
  }
  .head-comp-section-left {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    h1 {
      font-size: 2rem;
      font-weight: bold;
      line-height: 2rem;
      text-align: center;
      margin-bottom: 0px;
    }
  }

  .tool {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .section {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 1rem;
        font-weight: 600;
        margin-right: 5px;
      }
      padding-right: 20px;
    }
  }
}

@media screen and (max-width:1000px) {
  h1 {
    font-size: 1.5rem;
  }
  .head-comp > .menuheader {
    display: block;
  }
}
</style>
